<template>
    <div class="BestTeam">
        <div>
            <el-row>
                
                <el-button v-for="(i,index) in buttonArr" :key="index" :class="active == index ? 'activeCLass' : ''" @click="handlePosition(i.code,index)">{{i.text}}</el-button>
                <!-- <el-button @click="handlePosition('MB')">副攻</el-button>
                <el-button @click="handlePosition('OS')">接应</el-button>
                <el-button @click="handlePosition('S')">二传</el-button>
                <el-button @click="handlePosition('L')">自由人</el-button> -->
            </el-row>
        </div>
        <div class="BestTeam_box">
            <el-table
                :data="data_table.StatEntities"
                :header-cell-style="{'textAlign': 'center'}"
                :cell-style="{'textAlign': 'center'}"
                :row-class-name="TableRowClassName"
                style="width: 100%">
                <el-table-column
                label=""
                width="50">
                    <template slot-scope="scope">
                        <div>{{ scope.row.Rank}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                prop="date"
                label="球员"
                width="250">
                    <template slot-scope="scope">
                        <div>
                            <p>{{ scope.row.AthleteName}}</p>
                            <p>({{ scope.row.TeamName}})</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="已完成">
                    <el-table-column
                    label="比赛"
                    width="70">
                        <template slot-scope="scope">
                            <div>{{ scope.row.MatchCount}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="局"
                    width="70">
                        <template slot-scope="scope">
                            <div>{{scope.row.SetCount}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="发球" v-if="show_Normal">
                    <el-table-column
                    prop="province"
                    label="#"
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Service6}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="="
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Service1}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="/"
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Service3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="总计"
                    width="60">
                        <template slot-scope="scope">
                            <div>{{scope.row.ServiceTot}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="拦网" v-if="show_Normal">
                    <el-table-column
                    label="#"
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Block6}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="="
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Block1}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="/"
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Block3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="总计"
                    width="60">
                        <template slot-scope="scope">
                            <div>{{scope.row.BlockTot}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="进攻" v-if="show_Normal">
                    <el-table-column
                    label="#"
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Attack6}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="="
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Attack1}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="/"
                    width="45">
                        <template slot-scope="scope">
                            <div>{{scope.row.Attack3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="总计"
                    width="60   ">
                        <template slot-scope="scope">
                            <div>{{scope.row.AttackTot}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column :label="table_head" v-if="show_Williams">
                    <el-table-column
                    label="#"
                    width="60">
                        <template slot-scope="scope">
                            <div>{{scope.row.SetRecv6}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="!"
                    v-if="show_Williams_er"
                    width="60">
                        <template slot-scope="scope">
                            <div>{{scope.row.SetRecv2}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="/"
                    v-if="show_Williams_er"
                    width="60">
                        <template slot-scope="scope">
                            <div>{{scope.row.SetRecv3}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="-"
                    v-if="show_Williams_er"
                    width="60">
                        <template slot-scope="scope">
                            <div>{{scope.row.SetRecv4}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="+"
                    v-if="show_Williams_er"
                    width="60">
                        <template slot-scope="scope">
                            <div>{{scope.row.SetRecv5}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    label="="
                    width="60">
                        <template slot-scope="scope">
                            <div>{{scope.row.SetRecv1}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column
                    v-if="show_Williams_er"
                    label="Tot"
                    >
                        <template slot-scope="scope">
                            <div>{{scope.row.SetRecvTot}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="排名">
                    <el-table-column
                    :label="table_head_2"
                    >
                    <!-- width="174" -->
                        <template slot-scope="scope">
                            <div>{{scope.row.RankRatio}}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
                
                
            </el-table>

            <el-card class="box-card BestTeam_commont">
                <div slot="header" class="clearfix">
                    <span>排名计算</span>
                </div>
                <div class="BestTeam_commont_t">公式</div>
                <ul class="CardList">
                    <li>{{data_table.Formula}}</li>
                </ul>
                
                <div class="BestTeam_commont_t">计算公式注释</div>
                <div>{{data_table.SetCount}}</div>
                <ul class="CardList">
                    <!-- <li>{{data_table.FilterDes1}}</li> -->
                    <li v-for="(i,index) in data_table.Legend" :key="index">{{i}}</li>
                </ul>
                <div class="BestTeam_commont_t">筛选条件</div>
                <div>{{data_table.SetCount}}</div>
                <ul class="CardList">
                    <li>{{data_table.FilterDes1}}</li>
                    <li v-if="data_table.FilterDes2 !=''">{{data_table.FilterDes2}}</li>
                </ul>
            </el-card>




        </div>


    </div>
</template>
<script>
import http from '@/assets/js/http.js';
export default {
    data() {
      return {
        tableData: [{
          date: '2016-05-03',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-02',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-04',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-01',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-08',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-06',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }, {
          date: '2016-05-07',
          name: '王小虎',
          province: '上海',
          city: '普陀区',
          address: '上海市普陀区金沙江路 1518 弄',
          zip: 200333
        }],
        buttonArr:[{text:'主攻',code:'WS'},
        {text:'副攻',code:'MB'},
        {text:'接应',code:'OS'},
        {text:'二传',code:'S'},
        {text:'自由人',code:'L'}],
        my_data: null,
        data_table: {},
        show_Williams: false,
        show_Williams_er:true,
        show_Normal: true,
        table_head: '传球',
        table_head_2: '有效得分指数',
        The_formula: "('A#' + 'B#' + 'S#')/局 - ('A/' + 'A=')/局",
        courtPosition: 'WS',
        active: 0,
      }
    },
    watch: {
        $route: { // 用来监听query参数变化
            handler() {
                //深度监听，同时也可监听到param参数变化
                let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key));
                this.my_data = params;
                // console.log(params)
                this.GetPlayerAll('/GetPlayerStatList',params.EventID,this.courtPosition);//最佳阵容-主攻
            },
            deep: true,
        }
    },
    created(){
        let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
        this.my_data = params;
        // console.log(params)
        // this.GetSportTeamList(this.my_data.sportID)//获取队伍列表
    },
    mounted(){
        
        this.GetPlayerAll('/GetPlayerStatList',this.my_data.EventID,'WS');//最佳阵容-主攻
        
        // this.PhaseID = this.$cookie.get('PhaseID');
        // this.GetMatchResultList(this.PhaseID,-1)//获取比赛成绩列表
    },
    methods: {
        TableRowClassName({row, rowIndex}) {
            if ((rowIndex)%2==0) {
                return 'statistics-warning-row';
            } else {
                return '';
            }
        },
        handlePosition(txt,index){//点击场上运动员位置
            console.log(txt)
            this.active = index;
            this.courtPosition = txt;
            if(txt == 'S' || txt == 'L'){
                this.show_Williams = true;
                this.show_Normal = false;
                // if(txt == 'S'){
                //     this.show_Williams_er = false;
                // }else{
                    this.show_Williams_er = true;
                // }
            }else{
                this.show_Williams = false;
                this.show_Normal = true;
                this.table_head_2 = '有效得分指数';
            }
            if(txt == 'WS'){
                this.The_formula = "('A#' + 'B#' + 'S#')/局 - ('A/' + 'A=')/局";
            }else if(txt == 'OS'){
                this.The_formula = "('A#' + 'B#' + 'S#')/局 - ('A/' + 'A=')/局";
            }else if(txt == 'MB'){
                this.The_formula = "('A#' + 'B#' + 'S#')/局 - ('A/' + 'A=')/局";
            }else if(txt == 'S'){
                this.table_head = '传球';
                this.table_head_2 = '二传指数';
                this.The_formula = "('E#' - 'E=')/局";
            }else if(txt == 'L'){
                this.table_head = '一传';
                this.table_head_2 = '一传指数';
                this.The_formula = "('R#' - 'R=')/局";
            }
            this.GetPlayerAll('/GetPlayerStatList',this.my_data.EventID,txt);//最佳阵容-主攻
        },
        GetPlayerAll(url,EventID,Position){//最佳阵容
            http.GetPlayerAll(url,EventID,Position).then(res=>{//最佳阵容
                // console.log(res)
                if(res.Status == 1){
                    this.data_table = res.DataResult;
                }else if(res.Status == 0){
                    this.$message.error({message:'暂无数据!',duration: 1500,showClose: true,});
                }else{
                    this.$message.error({
                        message:'获取信息失败!',
                        duration: 1500,
                        showClose: true,
                    });
                    
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    ::v-deep .el-table__row.statistics-warning-row {
        background: #ddd;
    }
    .BestTeam{
        max-width: 1200px;
        margin: 20px auto;
        font-size: 16px;
        // background: white;
    }
    .BestTeam_box{
        width: 100%;
        margin-top: 20px;
    }
    .BestTeam_commont{
        margin-top: 20px;
        text-align: left;
        .clearfix{
            text-align: center;
        }
        li{
            list-style: disc;
            line-height: 20px;
            margin-left: 20px;
        }
        .BestTeam_commont_t{
            font-size: 18px;
            font-weight: bold;
        }
    }
    .activeCLass{
        color: #409EFF;
        background-color: #ecf5ff;
        border-color: #c6e2ff; 
        // outline-color: rgb(64, 158, 255); 
    }
</style>